<template>
  <div :id="id"
       class="v-tab-items tab-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VTabItems',
  data() {
    return {}
  },
  props: {
    id: String,
  },
  computed: {},
  methods: {
    addActive() {
      const tabs = this.$slots.default;
      let isAnyoneActive = false;

      if (!!tabs) {
        isAnyoneActive = tabs.some(tab => tab.componentInstance.$props.active);

        if (!isAnyoneActive) {
          tabs[0].elm.classList.add('active', 'show');
        }
      }
    },
  },
  mounted() {
    this.addActive();
  }
};
</script>

<style lang="scss">
@import "VTabs";
</style>
